import { Control, FieldValues, Path } from "react-hook-form";
import { formInputClassName } from "../../../styles/input";
import { cn } from "../../../utils";
import { Textarea, TextareaProps } from "../Textarea";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "./Form";

type FormTextareaProps<TForm extends FieldValues> = {
  control: Control<TForm>;
  name: Path<TForm>;
  className?: string;
  containerClassName?: string;
  label: string;
  placeholder?: string;
  hasMessage?: boolean;
  errorRing?: boolean;
} & TextareaProps;

export function FormTextarea<TForm extends FieldValues>({
  control,
  name,
  className,
  containerClassName,
  label,
  placeholder,
  hasMessage = false,
  errorRing = true,
  ...props
}: FormTextareaProps<TForm>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FormItem className={cn(formInputClassName, containerClassName)}>
          <FormLabel>{label}</FormLabel>
          <FormControl>
            <Textarea
              placeholder={placeholder}
              className={cn("resize-none", className, {
                "ring-destructive focus-visible:ring-destructive focus-visible:ring-offset-background ring-1 focus-visible:ring-offset-1":
                  fieldState.error && errorRing,
              })}
              {...field}
              {...props}
            />
          </FormControl>
          {hasMessage ? <FormMessage /> : null}
        </FormItem>
      )}
    />
  );
}

export default FormTextarea;
